/* eslint-disable jsx-a11y/anchor-has-content */
import { KPI_VALUE_CLASSIC } from '@/utils/hooks/format/useFormatKpiValue';

// Lib
import faqUrl from '@/utils/urls/faqUrl';

// Components
import { colors } from '@/lib/analytics/colors';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { SIZE_25 } from '@/lib/gridElements/size';
import { url_faq_reach_impressions } from '@/lib/urls/faqUrls';

import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { DefaultLoader } from '@/components/base/Kpi/KpiLoader';
import { Trans } from '@/components/tools/translation';

export const reachConfig = {
    name: 'kpi.instagram.reach',
    id: 'reach',
    icon: {
        name: 'reach',
        style: colors.yellow
    },
    tooltip: (
        <Trans
            i18nKey="analytics:kpi.instagram.tooltip_reach"
            components={{
                LinkFaq: (
                    <a
                        target="_blank"
                        href={faqUrl(url_faq_reach_impressions)}
                        className="text-icoBlue underline"
                        rel="help noopener noreferrer"
                    />
                )
            }}
        />
    ),
    growth_tooltip: {
        up: 'analytics:kpi.growth_tooltip.up',
        down: 'analytics:kpi.growth_tooltip.down',
        still: 'analytics:kpi.growth_tooltip.still'
    },
    mergedData: true,
    data_format: KPI_VALUE_CLASSIC,
    size: SIZE_25,
    orientation: ORIENTATION_VERTICAL,
    type: 'kpi',
    loader: DefaultLoader,
    element: KPIDefault
};
